import { render } from "./animated-wishlist-button.vue?vue&type=template&id=b413c504"
import script from "./animated-wishlist-button.vue?vue&type=script&lang=js"
export * from "./animated-wishlist-button.vue?vue&type=script&lang=js"

import "./animated-wishlist-button.vue?vue&type=style&index=0&id=b413c504&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__